import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/admin/src/app/global-error.tsx");
